export var SecurityLevel;
(function (SecurityLevel) {
    SecurityLevel["L1_Encrypted"] = "L1_Encrypted";
    SecurityLevel["L2_DeviceUnlocked"] = "L2_DeviceUnlocked";
    SecurityLevel["L3_UserPresence"] = "L3_UserPresence";
    SecurityLevel["L4_Biometrics"] = "L4_Biometrics";
})(SecurityLevel || (SecurityLevel = {}));
//# sourceMappingURL=definitions.js.map